// DEPRECATED(formsy-retirement): legacy formsy-react field. Use a Formik-based field instead.
import '@sophocles/components/FormFields/TextBox/styles.scss';

import { FormControl, FormHelperText } from '@mui/material';
import TextField from '@mui/material/TextField';
import { withFormsy } from 'formsy-react';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

function TextBox(props) {
  const {
    helperText,
    title,
    errorMessage,
    showRequired,
    error, // manually passed in error.
    value,
    setValue,
    passValue,
    ...otherProps
  } = props;

  const { t } = useTranslation();

  const changeValue = event => {
    const { value } = event.currentTarget;
    setValue(value);
    if (typeof passValue === 'function') {
      passValue(value);
    }
  };

  // Determine error message
  let errorText = '';
  if (errorMessage) {
    errorText = errorMessage;
  } else if (error) {
    errorText = error;
  } else if (showRequired) {
    errorText = t('general.thisFieldIsRequired');
  }

  // Only include props needed for the TextField
  const trimmedProps = _.pick(otherProps, [
    'fullWidth',
    'multiline',
    'rows',
    'rowsMax',
    'maxLength',
    'max',
    'min',
    'type',
    'disabled',
    'style',
    'InputProps',
    'inputProps',
    'sx',
  ]);

  return (
    <FormControl fullWidth={props.fullWidth ?? false} error={!!errorText}>
      <TextField
        variant="standard"
        error={!!error}
        label={title}
        onChange={changeValue}
        value={value}
        helperText={helperText}
        {...trimmedProps}
      />
      <FormHelperText>{errorText}</FormHelperText>
    </FormControl>
  );
}

export default withFormsy(TextBox);
